import { createCanBoundTo } from '@casl/react';
import ability from './ability';
import { widgetType } from './permissionsMapping';

export default createCanBoundTo(ability);

export const canViewWidget = name =>
  !widgetType[name] ||
  ability.can('view', widgetType[name]) ||
  canEditWidget(name);

export const canEditWidget = name =>
  !widgetType[name] || ability.can('edit', widgetType[name]);

export const canExecuteWidget = name =>
  !widgetType[name] || ability.can('execute', widgetType[name]);

export const canViewSubject = subject =>
  ability.can('view', subject) || canEditSubject(subject);

export const canEditSubject = subject => ability.can('edit', subject);

export const canExecuteSubject = subject => ability.can('execute', subject);

export const canDeleteSubject = subject => ability.can('delete', subject);
